import { Alert, Box, Chip, Collapse, Container, Divider, Grid, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import "moment/locale/ca";
import PageAdmin from "../components/PageAdmin";
import CustomButton from "../components/CustomButton";
import { useFieldArray, useForm } from "react-hook-form";
import CustomTextField from "../components/CustomTextField";
import { comparses } from "../data/comparses";
import { useSnackbar } from "notistack";
import moment from "moment/moment";
import clsx from "clsx";
import CustomCheckbox from "../components/CustomCheckbox";
import { Inscrits, Opcions } from "../db/firebase";
import Page from "../components/Page";
import { useNavigate } from "react-router-dom";
import { sendEmail } from "../db/emails";

export default function Home() {
	const classes = useStyles();
	const [pas, setPas] = useState(1);
	const { enqueueSnackbar } = useSnackbar();
	const [loadingI, errorI, inscrits, getInscrits, addInscrit, removeInscrit] = Inscrits();
	const [loadingO, errorO, opcions, getOpcions, editarOpcions] = Opcions();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		getInscrits();
		getOpcions();
	}, []);

	useEffect(() => {
		console.log(Object.entries(opcions?.comparses ?? []).find((i) => i[0] === "turcs"));
	}, [opcions]);

	const {
		register,
		handleSubmit,
		watch,
		setValue,
		control,
		formState: { errors },
	} = useForm({
		mode: "onTouched",
	});

	const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
		control,
		name: "comparses",
	});

	const seguentPas = () => {
		window.scrollTo(0, 0);
		if (pas === 1) {
			if (watch("data_n_nen")) {
				setPas((prev) => prev + 1);
			} else {
				enqueueSnackbar("Falten dades per omplir", {
					variant: "error",
				});
			}
		}
		if (pas === 2) {
			if (watch("nom_nen") && watch("cognoms_nen") && watch("dni_nen").length > 8) {
				if (
					inscrits.some(
						(c) =>
							c.dni_nen.toLowerCase().replace(/[^a-zA-Z0-9]/g, "") ===
							watch("dni_nen")
								.toLowerCase()
								.replace(/[^a-zA-Z0-9]/g, "")
					)
				) {
					enqueueSnackbar("DNI repetit", {
						variant: "error",
					});
				} else {
					setPas((prev) => prev + 1);
				}
			} else {
				enqueueSnackbar("Falten dades per omplir o el DNI no és correcte", {
					variant: "error",
				});
			}
		}
		if (pas === 3) {
			if (watch("nom") && watch("cognoms") && watch("dni") && watch("email") && watch("telefon") && watch("data_n")) {
				setPas((prev) => prev + 1);
			} else {
				enqueueSnackbar("Falten dades per omplir", {
					variant: "error",
				});
			}
		}
		if (pas === 4) {
			if (watch("comparses")?.length > 0) {
				if (watch("comparses")?.includes("plens") || watch("comparses")?.includes("plens2")) {
					if (
						watch("nom_acompanyant") &&
						watch("cognoms_acompanyant") &&
						watch("dni_acompanyant") &&
						watch("alcada") &&
						watch("data_n_acompanyant")
					) {
						setPas((prev) => prev + 1);
					} else {
						enqueueSnackbar("Falten dades per omplir", {
							variant: "error",
						});
					}
				} else {
					setPas((prev) => prev + 1);
				}
			} else {
				enqueueSnackbar("Selecciona, al menys, una comparsa", {
					variant: "error",
				});
			}
		}
	};

	const addRemoveComparsa = (id) => {
		if (watch("comparses").includes(id)) {
			const aux = watch("comparses");
			const index = aux.indexOf(id);
			if (index > -1) {
				aux.splice(index, 1);
			}
			setValue("comparses", aux);
		} else {
			if (watch("comparses").length >= 5) {
				enqueueSnackbar("No es poden seleccionar més de 5 comparses. Desactiva'n alguna per afegir-ne una de nova.", {
					variant: "error",
				});
			} else {
				append(id);
			}
		}
	};

	const inscriure = async (values) => {
		values.numero = inscrits?.length + 1;
		setLoading(true);
		try {
			await addInscrit(values);
			await sendEmail(values);
			navigate("ok");
			enqueueSnackbar("Inscripció realitzada!", {
				variant: "success",
			});
		} catch (error) {
			enqueueSnackbar("Alguna cosa no ha anat bé. Torna-ho a intentar més tard.", {
				variant: "error",
			});
		}
		setLoading(false);
	};

	const comprovarEdat = (Comparsa) => {
		if (Comparsa.id === "plens" || Comparsa.id === "plens2") {
			return isBetween(
				Number(moment(opcions?.data_patum, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")),
				Number(Object.entries(opcions?.comparses ?? []).find((i) => i?.[0] === Comparsa?.id)?.[1]?.edatMin),
				Number(Object.entries(opcions?.comparses ?? []).find((i) => i?.[0] === Comparsa?.id)?.[1]?.edatMax)
			);
		} else {
			return isBetween(
				Number(moment(opcions?.data_assaig, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")),
				Number(Object.entries(opcions?.comparses ?? []).find((i) => i?.[0] === Comparsa?.id)?.[1]?.edatMin),
				Number(Object.entries(opcions?.comparses ?? []).find((i) => i?.[0] === Comparsa?.id)?.[1]?.edatMax)
			);
		}
	};

	function isBetween(n, a, b) {
		return (n - a) * (n - b) <= 0;
	}

	return (
		<Page title="Inscripció Patum Infantil">
			<Container maxWidth="md">
				{!opcions?.obertes ? (
					<Alert severity="warning">Inscripcions Tancades</Alert>
				) : (
					<form onSubmit={handleSubmit(inscriure)}>
						<Collapse in={pas === 1}>
							<Titol titol="Data de naixement de l'infant" pas={1} />
							<CustomTextField
								register={register}
								name={"data_n_nen"}
								label={"Data naixement infant"}
								type={"date"}
								InputProps={{ inputProps: { max: moment().format("YYYY-MM-DD") } }}
								InputLabelProps={{
									shrink: true,
								}}
								fullWidth
							/>
						</Collapse>
						<Collapse in={pas === 2}>
							<Titol titol="Dades nen" pas={2} />
							<Grid spacing={2} container>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"nom_nen"}
										label={"Nom infant"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"cognoms_nen"}
										label={"Cognoms infant"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
							</Grid>
							<CustomTextField
								register={register}
								name={"dni_nen"}
								label={"DNI o número de targeta sanitària infant"}
								InputLabelProps={{
									shrink: true,
								}}
								fullWidth
								mt={4}
							/>
						</Collapse>
						<Collapse in={pas === 3}>
							<Titol titol="Dades pare/mare/tutor" pas={3} />
							<Grid spacing={2} container>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"nom"}
										label={"Nom"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"cognoms"}
										label={"Cognoms"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
							</Grid>
							<Grid spacing={2} container mt={3}>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"email"}
										label={"E-mail"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"telefon"}
										label={"Telèfon"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
							</Grid>
							<Grid spacing={2} container mt={3}>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"dni"}
										label={"DNI"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<CustomTextField
										register={register}
										name={"data_n"}
										label={"Data naixement"}
										type={"date"}
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
									/>
								</Grid>
							</Grid>
						</Collapse>

						<Collapse in={pas === 4}>
							<Titol titol="Selecciona les comparses" pas={4} />

							<Typography color="white" style={{ fontSize: 14 }} textAlign={"center"}>
								Selecciona fins a 5 comparses per ordre de preferència
							</Typography>
							<Box textAlign={"center"} my={3}>
								<Chip
									size="small"
									variant="outlined"
									color="secondary"
									label={"Edat de l'infant el dia d'assaig: " + moment(opcions?.data_assaig, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")}
								/>
								<Box mt={1} />
								<Chip
									size="small"
									variant="outlined"
									color="secondary"
									label={"Edat de l'infant el dia de Patum: " + moment(opcions?.data_patum, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")}
								/>
							</Box>

							<Grid spacing={3} container>
								{comparses?.map((Comparsa) => (
									<Grid item sm={6} xs={12} lg={3}>
										<Box
											className={clsx(
												classes.comparsa,
												watch("comparses")?.includes(Comparsa.id) && classes.comparsaActiva,
												!comprovarEdat(Comparsa) && classes.disabled
											)}
											key={Comparsa.id}
											onClick={comprovarEdat(Comparsa) ? () => addRemoveComparsa(Comparsa.id) : () => {}}
										>
											{/* <Comparsa.icon style={{ width: 50, height: 50, fill: "white" }} /> */}
											<img src={Comparsa.png} alt={Comparsa.nom} style={{ width: 80, height: 80 }} />
											<Typography color="white">{Comparsa.nom}</Typography>
											<Typography color="white" variant="caption">
												De {Object.entries(opcions?.comparses ?? []).find((i) => i[0] === Comparsa.id)?.[1]?.edatMin} a{" "}
												{Object.entries(opcions?.comparses ?? []).find((i) => i[0] === Comparsa.id)?.[1]?.edatMax} anys
											</Typography>
											{watch("comparses")?.indexOf(Comparsa.id) >= 0 && (
												<Box className={classes.ordre}>
													<Typography color="white" variant="caption">
														{watch("comparses")?.indexOf(Comparsa.id) + 1}
													</Typography>
												</Box>
											)}
										</Box>
									</Grid>
								))}
							</Grid>
							<Collapse in={watch("comparses")?.includes("plens") || watch("comparses")?.includes("plens2")}>
								<Typography color="white" style={{ fontSize: 20 }} textAlign={"center"} mt={5}>
									Dades en cas de seleccionar Plens
								</Typography>
								<Grid spacing={3} container mt={2}>
									<Grid item md={6} xs={12}>
										<CustomTextField
											register={register}
											name={"alcada"}
											label={"Alçada de l'infant (en cm, ex: 140)"}
											type="number"
											InputLabelProps={{
												shrink: true,
											}}
											fullWidth
										/>
									</Grid>
								</Grid>
								<Grid spacing={3} container mt={2}>
									<Grid item md={6} xs={12}>
										<CustomTextField
											register={register}
											name={"nom_acompanyant"}
											label={"Nom acompanyant"}
											InputLabelProps={{
												shrink: true,
											}}
											fullWidth
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<CustomTextField
											register={register}
											name={"cognoms_acompanyant"}
											label={"Cognoms acompanyant"}
											InputLabelProps={{
												shrink: true,
											}}
											fullWidth
										/>
									</Grid>

									<Grid item md={6} xs={12}>
										<CustomTextField
											register={register}
											name={"data_n_acompanyant"}
											label={"Data naixement de l'acompanyant"}
											type={"date"}
											InputLabelProps={{
												shrink: true,
											}}
											fullWidth
										/>
									</Grid>
									<Grid item md={6} xs={12}>
										<CustomTextField
											register={register}
											name={"dni_acompanyant"}
											label={"DNI acompanyant"}
											InputLabelProps={{
												shrink: true,
											}}
											fullWidth
										/>
									</Grid>
								</Grid>
							</Collapse>
						</Collapse>
						<Stack direction={"row"} justifyContent={"center"} spacing={3} pt={5} pb={3}>
							{pas > 1 && (
								<Box my={2}>
									<CustomButton light fullWidth onClick={() => setPas((prev) => prev - 1)} title="Tornar" />
								</Box>
							)}

							{pas <= 4 && (
								<Box my={2}>
									<CustomButton light fullWidth onClick={seguentPas} title="Següent" />
								</Box>
							)}
						</Stack>
						<Collapse in={pas === 5}>
							<Titol titol="Comprova les dades" pas={5} />
							<Box className={classes.bloc} mb={3}>
								<Typography>Dades infant</Typography>
								<Divider />

								<Grid container spacing={3} mb={3} mt={1}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Data naixement infant
										</Typography>
										<Typography>{moment(watch("data_n_nen")).format("DD/MM/YYYY")}</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={3} mb={3}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Edat infant
										</Typography>
										<Typography>{moment().diff(watch("data_n_nen"), "years")} anys</Typography>
									</Grid>

									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Edat el primer dia d'assaig
										</Typography>
										<Typography>{moment(opcions?.data_assaig, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")} anys</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Edat per patum
										</Typography>
										<Typography>{moment(opcions?.data_patum, "YYYY-MM-DD").diff(watch("data_n_nen"), "years")} anys</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={3} mb={5}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Nom infant
										</Typography>
										<Typography>{watch("nom_nen")}</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Cognoms infant
										</Typography>
										<Typography>{watch("cognoms_nen")}</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											DNI o número de targeta sanitària infant
										</Typography>
										<Typography>{watch("dni_nen")}</Typography>
									</Grid>
								</Grid>
								<Typography>Dades pare/mare/tutor</Typography>
								<Divider />

								<Grid container spacing={3} mb={3} mt={1}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Data naixement
										</Typography>
										<Typography>{moment(watch("data_n")).format("DD/MM/YYYY")}</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={3} mb={3}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Nom
										</Typography>
										<Typography>{watch("nom")}</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Cognoms
										</Typography>
										<Typography>{watch("cognoms")}</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											DNI
										</Typography>
										<Typography>{watch("dni")}</Typography>
									</Grid>
								</Grid>
								<Grid container spacing={3} mb={3}>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											E-mail
										</Typography>
										<Typography>{watch("email")}</Typography>
									</Grid>
									<Grid item md={4} xs={12}>
										<Typography variant="caption" color={"gray"}>
											Telèfon
										</Typography>
										<Typography>{watch("telefon")}</Typography>
									</Grid>
								</Grid>
								<Typography pt={3}>Comparses apuntades</Typography>
								<Divider />
								<Grid spacing={3} container mt={1}>
									{watch("comparses")?.map((comparsa, index) => {
										const Comp = comparses.find((c) => c.id === comparsa);
										return (
											<Grid item md={6} xs={12}>
												<Box className={classes.comparsaPetita}>
													{/* <Comp.icon style={{ width: 30, height: 30, fill: "white" }} /> */}
													<img src={Comp.png} alt={Comp.nom} style={{ width: 40, height: 40 }} />
													<Typography color="white" ml={2}>
														{Comp.nom}
													</Typography>
													<Box className={classes.ordreB}>
														<Typography color="primary" variant="caption">
															{index + 1}
														</Typography>
													</Box>
												</Box>
											</Grid>
										);
									})}
								</Grid>
								<Collapse in={watch("comparses")?.includes("plens") || watch("comparses")?.includes("plens2")}>
									<Typography pt={3}>Dades en cas de seleccionar Plens</Typography>
									<Divider />
									<Grid container spacing={3} mb={3} mt={1}>
										<Grid item md={4} xs={12}>
											<Typography variant="caption" color={"gray"}>
												Alçada infant
											</Typography>
											<Typography>{watch("alcada")} cm</Typography>
										</Grid>
									</Grid>
									<Grid container spacing={3} mb={3}>
										<Grid item md={6} xs={12}>
											<Typography variant="caption" color={"gray"}>
												Nom acompanyant
											</Typography>
											<Typography>{watch("nom_acompanyant")}</Typography>
										</Grid>
										<Grid item md={6} xs={12}>
											<Typography variant="caption" color={"gray"}>
												Cognoms acompanyant
											</Typography>
											<Typography>{watch("cognoms_acompanyant")}</Typography>
										</Grid>
										<Grid item md={6} xs={12}>
											<Typography variant="caption" color={"gray"}>
												DNI acompanyant
											</Typography>
											<Typography>{watch("dni_acompanyant")}</Typography>
										</Grid>
										<Grid item md={6} xs={12}>
											<Typography variant="caption" color={"gray"}>
												Data naixement acompanyant
											</Typography>
											<Typography>{moment(watch("data_n_acompanyant")).format("DD/MM/YYYY")}</Typography>
										</Grid>
									</Grid>
								</Collapse>
							</Box>
							<Box className={classes.bloc}>
								<Typography variant="caption">Es comprovaran que les dades siguin correctes el dia del sorteig.</Typography>
								<br />
								<Typography variant="caption">Si les dades no són correctes, la inscripció es donarà per errònia i serà anul·lada.</Typography>
								<Typography style={{ fontSize: 13 }} mb={1} mt={2}>
									Tractament de les dades de les inscripcions dels participants
								</Typography>
								<Typography style={{ fontSize: 13 }} mb={1}>
									Informació bàsica sobre Protecció de dades
								</Typography>
								<Typography style={{ fontSize: 13 }} mb={1}>
									Responsable: ASSOCIACIÓ PER LA PÀTUM INFANTIL; Finalitat: Prestar els serveis sol·licitats i enviar comunicacions
									promocionals; Drets: Té dret a accedir, rectificar i suprimir les dades, així com altres drets, indicats a la informació
									addicional, que pot exercir dirigint-se a comunicacio@patuminfantil.cat o Gran Via, 25 3r 3a - 08600 - Berga - Barcelona;
									Procedència: Del propi interessat o pares i/o tutors; Informació addicional:
									<a href="/politica-privacitat" target="_blank">
										https://sorteig-patum-infantil.vercel.app/politica-privacitat
									</a>
									.
								</Typography>
								<CustomCheckbox
									control={control}
									label={
										<Typography variant="caption">
											He llegit i accepto la{" "}
											<a href="/politica-privacitat" target="_blank">
												Política de Privacitat
											</a>
										</Typography>
									}
									name={"accepta"}
									setValue={setValue}
									required
								/>
							</Box>
						</Collapse>

						{pas === 5 && (
							<Box my={2} mb={20}>
								<CustomButton fullWidth type="submit" title="Apuntar" light loading={loading} />
							</Box>
						)}
					</form>
				)}
			</Container>
		</Page>
	);
}

const Titol = ({ titol, pas }) => {
	return (
		<Box mb={6} mt={4} textAlign={"center"}>
			<Typography variant="h3" color="white" mb={1}>
				{titol}
			</Typography>
			<Chip color="secondary" label={pas + "/5"} sx={{ fontFamily: "Varela Round" }} />
		</Box>
	);
};

const useStyles = makeStyles((theme) => ({
	bloc: {
		backgroundColor: "white",
		padding: 20,
		borderRadius: 10,
	},
	comparsa: {
		border: "2px solid white",
		position: "relative",
		borderRadius: 20,
		padding: 20,
		textAlign: "center",
		transition: "0.2s",
		cursor: "pointer",
		"&:hover": {
			transform: "scale(1.1)",
		},
	},
	comparsaActiva: {
		backgroundColor: "white",
		"& .MuiTypography-root": {
			color: "#d9594e",
		},
		"& svg": {
			fill: "#d9594e !important",
		},
	},
	ordre: {
		backgroundColor: "#d9594e",
		width: 20,
		height: 20,
		borderRadius: 50,
		position: "absolute",
		top: 10,
		left: 10,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		"& .MuiTypography-root": {
			color: "white !important",
		},
	},
	ordreB: {
		backgroundColor: "white",
		width: 20,
		height: 20,
		borderRadius: 50,
		position: "absolute",
		top: 10,
		right: 10,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	comparsaPetita: {
		display: "flex",
		alignItems: "center",
		position: "relative",
		backgroundColor: "#d9594e",
		border: "2px solid white",
		borderRadius: 20,
		padding: 20,
	},
	disabled: {
		opacity: 0.3,
	},
}));

function removeValue(value, index, arr) {
	// If the value at the current array index matches the specified value (2)
	if (value === 2) {
		// Removes the value from the original array
		arr.splice(index, 1);
		return true;
	}
	return false;
}
